import { useState } from 'react';

const faqItems = [
  {
    question: '知識がなくても使えますか？',
    answer:
      'はい、デザインやコーディングの知識がなくてもお使いいただけます。チャットで伝えたい内容を入力するだけで、AIがLPの構成や文章を作成します。',
  },
  {
    question: '公開したあとも修正できますか？',
    answer:
      'はい、公開後もチャットで内容の修正ができます。文章の変更、セクションの追加・削除など、いつでも更新可能です。',
  },
  {
    question: 'どんな業種でも使えますか？',
    answer:
      'はい、業種を問わずお使いいただけます。サービス紹介、店舗案内、採用、キャンペーンなど、さまざまな用途に対応しています。',
  },
  {
    question: '無料で始められますか？',
    answer:
      'はい、無料プランでLPの作成をお試しいただけます。まずはアカウントを登録して、チャットからLPを作成してみてください。',
  },
];

function FaqAccordion({ question, answer }: { question: string; answer: string }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="border-b border-border">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between py-5 text-left group"
      >
        <span className="text-base font-medium text-primary pr-4">{question}</span>
        <svg
          className={`w-5 h-5 text-textMuted shrink-0 transition-transform duration-200 ${open ? 'rotate-180' : ''}`}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {open && (
        <div className="pb-5 pr-8 animate-fade-in">
          <p className="text-sm text-textMuted leading-relaxed">{answer}</p>
        </div>
      )}
    </div>
  );
}

export default function Faq() {
  return (
    <section id="faq" className="py-20 md:py-28 px-6 md:px-10">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-14">
          <span className="section-label">FAQ</span>
          <h2 className="section-title">よくある質問</h2>
        </div>

        <div>
          {faqItems.map((item) => (
            <FaqAccordion key={item.question} question={item.question} answer={item.answer} />
          ))}
        </div>
      </div>
    </section>
  );
}
